import React, { useState } from 'react'
import './Accordian.component.css'
import { IonCard, IonIcon, IonItem, IonLabel, IonToggle, useIonViewWillLeave } from '@ionic/react'
import { caretUp, caretDown, checkmarkSharp } from 'ionicons/icons'
import { useHistory } from 'react-router'
import { isInternalPicklistRoute } from '../../common/picklistRoutes.constants'
interface IAccordianProps {
  heading?: string
  content?: any
  hasToggle?: boolean
  dataTestId?: string
  toggleAction?: (toggleFlag: boolean) => void
  isCheckMark?: boolean
  isToggleChecked?: boolean
  action?: (toggleFlag: boolean) => void
  openAccordion?: boolean
  footerContent?: any
}

export const AccordianComponent: React.FC<IAccordianProps> = (props: IAccordianProps) => {
  const [showAccordionContent, setShowAccordionContent] = useState(false)
  const history = useHistory()
  const {
    heading,
    openAccordion,
    action,
    content,
    hasToggle,
    dataTestId,
    toggleAction,
    isCheckMark = false,
    isToggleChecked = false,
    footerContent,
  } = props

  const expandAccordion = openAccordion ?? showAccordionContent

  useIonViewWillLeave(() => {
    if (openAccordion !== undefined) return
    if (isInternalPicklistRoute(history.location.pathname)) return
    setShowAccordionContent(false)
  })

  const onAccordianClick = () => {
    const newState = !expandAccordion

    if (openAccordion === undefined) {
      setShowAccordionContent(newState)
    }
    action && action(newState)
  }

  return (
    <div id='accordianCard' data-testid={dataTestId}>
      <IonCard
        className={expandAccordion ? 'ion-border mb-16 m-0 border-none cardAnimate box-gradient' : 'm-0 border-none'}>
        {hasToggle && (
          <>
            <div className='ion-content'>
              <IonItem lines='none'>
                <IonToggle
                  slot='start'
                  name={heading}
                  className='pr-8'
                  onClick={() => {
                    const newState = !isToggleChecked
                    toggleAction && toggleAction(newState)

                    if (openAccordion === undefined) {
                      setShowAccordionContent(newState)
                    }
                    action && action(newState)
                  }}
                  color='zoll-blue-secondary'
                  checked={isToggleChecked}
                />
                <IonLabel
                  onClick={() => {
                    if (isToggleChecked) onAccordianClick()
                  }}
                  className='m-3 accordian-heading'>
                  <span className='accordian-heading-text'>{heading}</span>
                  {isCheckMark && <IonIcon color='success' className='check-icon' icon={checkmarkSharp} />}
                </IonLabel>
                <div className='accordian-header d-flex'>
                  {isToggleChecked && (
                    <div className='icon-content' onClick={onAccordianClick}>
                      {expandAccordion && (
                        <IonLabel color='primary-alt' className='mr-5'>
                          Close
                        </IonLabel>
                      )}
                      <IonIcon
                        slot='end'
                        size='small'
                        className={expandAccordion ? 'mr-10' : 'mr-10 chevron-icon'}
                        color={expandAccordion ? 'primary-alt' : 'zoll-darkBlue'}
                        icon={expandAccordion ? caretUp : caretDown}
                      />
                    </div>
                  )}
                </div>
              </IonItem>
            </div>
          </>
        )}
        {!hasToggle && (
          <IonItem lines='none' className='ion-no-margin accordian-header' onClick={onAccordianClick}>
            <IonLabel className='m-3 accordian-heading'>
              <span className='accordian-heading-text'>{heading}</span>
              {isCheckMark && <IonIcon color='success' className='check-icon' icon={checkmarkSharp} />}
            </IonLabel>
            <div className='icon-content'>
              {expandAccordion && (
                <IonLabel color='primary-alt' className='mr-5'>
                  Close
                </IonLabel>
              )}
              <IonIcon
                slot='end'
                size='small'
                className={expandAccordion ? 'mr-10' : 'chevron-icon mr-10'}
                color={expandAccordion ? 'primary-alt' : 'zoll-darkBlue'}
                icon={expandAccordion ? caretUp : caretDown}
              />
            </div>
          </IonItem>
        )}
        {!expandAccordion && <div className='dashed-border' />}
        <div className={expandAccordion ? 'accordian-content-show ion-no-padding' : 'accordian-content-hide'}>
          <div className='content-margin'>{content}</div>
          {footerContent && footerContent}
        </div>
      </IonCard>
    </div>
  )
}
